// import React from 'react'
import './services.css'
import React, {useState} from "react"

const Services = () => {

    const [toggleState, setToggleState] = useState (0)

    const toggleTab = (index) => {
        setToggleState(index);
    }
  return (
    <section className='services section' id='services'>
        <h2 className='section__title'>Services</h2>
        <span className='section__subtitle'>What I Offer</span>

        <div className='services__container container grid'>
            <div className='services__content'>
                <div>
                    <i className='uil uil-web-grid services__icon'></i>
                    <h3 className='services__title'>Web <br/> Developer</h3>
                </div>

                <span className='services__button' onClick={() => toggleTab(1)}> View More
                 <i className='uil uil-arrow-right services__button-icon'>

                </i></span>
                <div className={toggleState === 1 ? 'services__modal active-modal': "services__modal"}>
                    <div className='services__modal-content'>
                        <i onClick={() => toggleTab(0)} className='uil uil-times services__modal-close'></i>

                        <h3 className='services__modal-title'>Web Developer</h3>
                        <p className='services__modal-description'>
                        Passionate Full Stack Web Developer proficient in frontend and backend technologies. Committed in crafting seamless websites that meet client's goals
                        </p>

                        <ul className='services__modal-services grid'>
                            <li className='services__modal-service'>
                                <i className='uil uil-check-circle services__modal-icon'></i>
                                <p className='services__modal-info'>
                                    Proficient in HTML, CSS, Bootstrap, Tailwind
                                </p>

                            <li className='services__modal-service'>
                                <i className='uil uil-check-circle services__modal-icon'></i>
                                <p className='services__modal-info'>
                                Proficient in C++, Javascript 
                                </p>
                            </li>

                            <li className='services__modal-service'>
                                <i className='uil uil-check-circle services__modal-icon'></i>
                                <p className='services__modal-info'>
                                Proficient in MongoDB, SQL, NodeJS for backend
                                </p> 
                            </li>
                            </li>
                            {/* <li className='services__modal-service'>
                                <i className='uil uil-check-circle services__modal-icon'></i>
                                <p className='services__modal-info'>
                                    I can also provide technical solutions to your business idea and model according to my expertise
                                    </p>
                            </li> */}
{/*                             
                            <li className='services__modal-service'>
                                <i className='uil uil-check-circle services__modal-icon'></i>
                                <p className='services__modal-info'>
                                    I can also mentor your student by teaching them with web and programming
                                </p>
                            </li> */}
                        </ul>
                    </div>
                </div>
            </div>

            <div className='services__content'>
                <div>
                    <i className='uil uil-arrow services__icon'></i>
                    <h3 className='services__title'>UI/UX <br/> Designer</h3>
                </div>
                
                <span className='services__button' onClick={() => toggleTab(2)}> View More 
                 <i className='uil uil-arrow-right services__button-icon'>

                </i></span>
                <div className={toggleState === 2 ? 'services__modal active-modal': "services__modal"}>
                    <div className='services__modal-content'>
                        <i onClick={() => toggleTab(0)} className='uil uil-times services__modal-close'></i>

                        <h3 className='services__modal-title'>UI/UX Designer</h3>
                        <p className='services__modal-description'>
                       Passionate UI/UX Designer skilled in creating intuitive, visually appealing websites. Committed to enhancing user experiences for clients through Innovative Design
                        </p>

                        <ul className='services__modal-services grid'>
                            <li className='services__modal-service'>
                                <i className='uil uil-check-circle services__modal-icon'></i>
                                <p className='services__modal-info'>
                                Proficient in Canva, Figma for UI, Graphic Designing
                                </p>

                            <li className='services__modal-service'>
                                <i className='uil uil-check-circle services__modal-icon'></i>
                                <p className='services__modal-info'>
                                Proficient in Framer to include animations, svgs in UI
                                </p>
                            </li>

                            <li className='services__modal-service'>
                                <i className='uil uil-check-circle services__modal-icon'></i>
                                <p className='services__modal-info'>
                                Proficient in understanding user behavior towards UI/UX
                                </p> 
                            </li>
                            </li>
                            {/* <li className='services__modal-service'>
                                <i className='uil uil-check-circle services__modal-icon'></i>
                                <p className='services__modal-info'>
                                    I can also provide technical solutions to your business idea and model according to my expertise
                                    </p>
                            </li> */}
                            
                            {/* <li className='services__modal-service'>
                                <i className='uil uil-check-circle services__modal-icon'></i>
                                <p className='services__modal-info'>
                                    I can also mentor your student by teaching them with web and programming
                                </p>
                            </li> */}
                        </ul>
                    </div>
                </div>
            </div>


            <div className='services__content'>
                <div>
                    <i className='uil uil-edit services__icon'></i>
                    <h3 className='services__title'>Technical <br/> Consultant</h3>
                </div>

                <span className='services__button' onClick={() => toggleTab(3)}> View More
                 <i className='uil uil-arrow-right services__button-icon'>

                </i></span>
                
                    
                <div className={toggleState === 3 ? 'services__modal active-modal': "services__modal"}>
                <div className='services__modal-content'>
                        <i onClick={() => toggleTab(0)} className='uil uil-times services__modal-close'></i>

                        <h3 className='services__modal-title'>Technical Consultant</h3>
                        <p className='services__modal-description'>
                        Passionate technical consultant dedicated to delivering innovative solutions in problem solving, client collaboration at forefront technology.
                        </p>

                        <ul className='services__modal-services grid'>
                            <li className='services__modal-service'>
                                <i className='uil uil-check-circle services__modal-icon'></i>
                                <p className='services__modal-info'>
                                Proficient in terms of Problem Solving 
                                </p>

                            <li className='services__modal-service'>
                                <i className='uil uil-check-circle services__modal-icon'></i>
                                <p className='services__modal-info'>
                                Proficient in Marketing with an experience of online technical marketing
                                </p>
                            </li>

                            <li className='services__modal-service'>
                                <i className='uil uil-check-circle services__modal-icon'></i>
                                <p className='services__modal-info'>
                                Proficient in other Technical Consultations
                                </p> 
                            </li>
                            </li>
                            {/* <li className='services__modal-service'>
                                <i className='uil uil-check-circle services__modal-icon'></i>
                                <p className='services__modal-info'>
                                    I can also provide technical solutions to your business idea and model according to my expertise
                                    </p>
                            </li>
                            
                            <li className='services__modal-service'>
                                <i className='uil uil-check-circle services__modal-icon'></i>
                                <p className='services__modal-info'>
                                    I can also mentor your student by teaching them with web and programming
                                </p>
                            </li> */}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Services